import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';
import {
	GETWITHOPENPAY,
	GETWITHOUTOPENPAY,
	GETOPENPAYCREDENTIALS,
	ASSOCIATEOPENPAY,
	UPDATEASSOCIATION,
	GET_ERRORS,
	DELETEASSOCIATION,
} from './types';

const URL_GETWITHOPENPAY        = process.env.REACT_APP_API_URL + services.centersWithOpenPay;
const URL_GETWITHOUTOPENPAY     = process.env.REACT_APP_API_URL + services.centersWithoutOpenPay;
const URL_GETOPENPAYCREDENTIALS = process.env.REACT_APP_API_URL + services.getOpenpayCredentials;
const URL_ASSOCIATEOPENPAY      = process.env.REACT_APP_API_URL + services.associateOpenPay;
const URL_UPDATEASSOCIATION     = process.env.REACT_APP_API_URL + services.updateAssociation;
const URL_DELETEASSOCIATION     = process.env.REACT_APP_API_URL + services.deleteAssociation;

export const getWithOpenPay = (search, limit, page) => (dispatch) => {
	const URL =
		URL_GETWITHOPENPAY + '?search=' + search + '&limit=' + limit + '&page=' + page;
	axios
		.get(URL)
		.then((res) => {
			dispatch({
				type: GETWITHOPENPAY,
				payload: res.data.result,
			});
		})
		.catch((error) => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			});
		});
};

export const getWithoutOpenPay = () => (dispatch) => {
	axios
		.get(URL_GETWITHOUTOPENPAY)
		.then((res) => {
			dispatch({
				type: GETWITHOUTOPENPAY,
				payload: res.data.result,
			});
		})
		.catch((error) => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error),
			});
		});
};

export const getOpenpayCredentials = () => (dispatch) => {
	axios
		.get(URL_GETOPENPAYCREDENTIALS)
		.then((res) => {
			dispatch({
				type: GETOPENPAYCREDENTIALS,
				payload: res.data.result,
			});
		})
		.catch((error) => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			});
		});
};

export const associateOpenPay = (data) => (dispatch) => {
	axios
		.post(URL_ASSOCIATEOPENPAY, data)
		.then((res) => {
			dispatch({
				type: ASSOCIATEOPENPAY,
				payload: res.data.result,
			});
		})
		.catch((error) => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			});
		});
};

export const updateAssociation = (data) => (dispatch) => {
	axios
		.put(URL_UPDATEASSOCIATION, data)
		.then((res) => {
			dispatch({
				type: UPDATEASSOCIATION,
				payload: res.data.result,
			});
		})
		.catch((error) => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			});
		});
};

export const deleteAssociation = (id) => (dispatch) => {
	const urldelete = URL_DELETEASSOCIATION + id;
	axios
		.delete(urldelete)
		.then((res) => {
			dispatch({
				type: DELETEASSOCIATION,
				payload: res.data.result,
			});
		})
		.catch((error) => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			});
		});
};
